export default "__VITE_ASSET__Deejn$3B__"